import React from 'react';
var ReactDOMServer = require('react-dom/server');

export const djsConfig = {
    autoProcessQueue: false,
    addRemoveLinks: true,
    maxFilesize: 5,
    acceptedFiles: 'image/png,image/jpeg,image/jpg,image/heif,image/heic,application/pdf', 
    init: function() {
        this.on("addedfile", function (file) { 
            let listType = ['image/jpeg', 'image/jpg', 'image/png','image/heif','image/heic','application/pdf']
            var _this = this;  
            let idx = listType.findIndex(type => type == file.type)
            if (idx == -1){
                _this.removeFile(file);
            } 
        });
    },
    previewTemplate: ReactDOMServer.renderToStaticMarkup(
        <div className="dz-preview dz-file-preview">
            <div className="dz-image">
                <img data-dz-thumbnail />
            </div>
            <div className="dz-details">
                <div className="dz-size">
                    <span data-dz-size></span>
                </div>
                <div className="dz-filename">
                    <span data-dz-name></span>
                </div> 
            </div>
            {/* <div className="dz-progress">
                <span className="dz-upload" data-dz-uploadprogress></span>
            </div>
            <div className="dz-error-message">
                <span data-dz-errormessage></span>
            </div> */}
            <div className="dz-success-mark">
                <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <title>Check</title>
                <defs></defs>
                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <path d="M23.5,31.8431458 L17.5852419,25.9283877 C16.0248253,24.3679711 13.4910294,24.366835 11.9289322,25.9289322 C10.3700136,27.4878508 10.3665912,30.0234455 11.9283877,31.5852419 L20.4147581,40.0716123 C20.5133999,40.1702541 20.6159315,40.2626649 20.7218615,40.3488435 C22.2835669,41.8725651 24.794234,41.8626202 26.3461564,40.3106978 L43.3106978,23.3461564 C44.8771021,21.7797521 44.8758057,19.2483887 43.3137085,17.6862915 C41.7547899,16.1273729 39.2176035,16.1255422 37.6538436,17.6893022 L23.5,31.8431458 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" strokeOpacity="0.198794158" stroke="#747474" fillOpacity="0.816519475" fill="#FFFFFF" />
                </g>
                </svg>
            </div>
            <div className="dz-error-mark">
                <svg width="54px" height="54px" viewBox="0 0 54 54" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <title>Error</title>
                    <defs></defs>
                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Check-+-Oval-2" stroke="#747474" strokeOpacity="0.198794158" fill="#DB2828">
                            <path d="M32.6568542,29 L38.3106978,23.3461564 C39.8771021,21.7797521 39.8758057,19.2483887 38.3137085,17.6862915 C36.7547899,16.1273729 34.2176035,16.1255422 32.6538436,17.6893022 L27,23.3431458 L21.3461564,17.6893022 C19.7823965,16.1255422 17.2452101,16.1273729 15.6862915,17.6862915 C14.1241943,19.2483887 14.1228979,21.7797521 15.6893022,23.3461564 L21.3431458,29 L15.6893022,34.6538436 C14.1228979,36.2202479 14.1241943,38.7516113 15.6862915,40.3137085 C17.2452101,41.8726271 19.7823965,41.8744578 21.3461564,40.3106978 L27,34.6568542 L32.6538436,40.3106978 C34.2176035,41.8744578 36.7547899,41.8726271 38.3137085,40.3137085 C39.8758057,38.7516113 39.8771021,36.2202479 38.3106978,34.6538436 L32.6568542,29 Z M27,53 C41.3594035,53 53,41.3594035 53,27 C53,12.6405965 41.3594035,1 27,1 C12.6405965,1 1,12.6405965 1,27 C1,41.3594035 12.6405965,53 27,53 Z" id="Oval-2" />
                        </g>
                    </g>
                </svg>
            </div>
        </div>
    )
  }
  